import { render, staticRenderFns } from "./learn3.vue?vue&type=template&id=0dfc3670&scoped=true"
import script from "./learn3.vue?vue&type=script&lang=js"
export * from "./learn3.vue?vue&type=script&lang=js"
import style0 from "./learn3.vue?vue&type=style&index=0&id=0dfc3670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc3670",
  null
  
)

export default component.exports